import { FileText, ImageIcon, Microscope, ClipboardPlus, Search } from 'lucide-react';

export interface AppEmptyStateConfig {
  title: string;
  description: string;
  icon: any; // Lucide icon component
  emptyStateTitle: string;
  variant: 'purple' | 'blue' | 'green' | 'default' | 'amber' | 'indigo';
  iconColor: string;
}

export const appEmptyStateConfigs: Record<string, AppEmptyStateConfig> = {
  'private-text-generator': {
    title: 'Document Generator',
    description: 'Create and manage your documents',
    icon: FileText,
    emptyStateTitle: 'Create Your First Document',
    variant: 'purple',
    iconColor: 'text-purple-500 dark:text-purple-400'
  },
  
  'private-image-generator': {
    title: 'Image Generator', 
    description: 'Generate and manage your AI images',
    icon: ImageIcon,
    emptyStateTitle: 'Create Your First Image',
    variant: 'blue',
    iconColor: 'text-blue-500 dark:text-blue-400'
  },
  
  'private-research-generator': {
    title: 'Your Research',
    description: 'Generate and manage your research',
    icon: Microscope,
    emptyStateTitle: 'Generate Your First Research',
    variant: 'green',
    iconColor: 'text-green-500 dark:text-green-400'
  },
  
  'project-manager': {
    title: 'Project Manager',
    description: 'Create and manage your projects',
    icon: FileText, // Will be Target icon
    emptyStateTitle: 'Create Your First Project',
    variant: 'purple',
    iconColor: 'text-purple-500 dark:text-purple-400'
  },
  
  'task-manager': {
    title: 'Task Manager',
    description: 'Organize and track your tasks',
    icon: ClipboardPlus,
    emptyStateTitle: 'Create Your First Task',
    variant: 'amber',
    iconColor: 'text-amber-500 dark:text-amber-400'
  },
  
  'project-team-tasks': {
    title: 'Team Tasks',
    description: 'Collaborate and track team progress',
    icon: ClipboardPlus,
    emptyStateTitle: 'Generate Tasks',
    variant: 'amber',
    iconColor: 'text-amber-500 dark:text-amber-400'
  },
  
  'project-team-pages': {
    title: 'Team Pages',
    description: 'Collaborate and create shared content',
    icon: FileText,
    emptyStateTitle: 'Create Your First Team Page',
    variant: 'purple',
    iconColor: 'text-purple-500 dark:text-purple-400'
  },
  
  'project-team-images': {
    title: 'Team Images',
    description: 'Collaborate and share visual content',
    icon: ImageIcon,
    emptyStateTitle: 'Create Your First Team Image',
    variant: 'blue',
    iconColor: 'text-blue-500 dark:text-blue-400'
  },
  
  'project-team-research': {
    title: 'Team Research',
    description: 'Collaborate and gather insights together',
    icon: Search,
    emptyStateTitle: 'Create Your First Team Research',
    variant: 'green',
    iconColor: 'text-green-500 dark:text-green-400'
  }
};

/**
 * Get configuration for a specific app
 */
export const getAppConfig = (appKey: string): AppEmptyStateConfig => {
  const config = appEmptyStateConfigs[appKey];
  if (!config) {
    throw new Error(`No configuration found for app: ${appKey}`);
  }
  return config;
}; 